export default class ClientRequestDocument {
    documentId: number;
    documentName: string;
    file: any;
}
